import { CellProps } from 'react-table'
import { EmpresasActionsCell } from './EmpresaActionsCell'
import { EmpresaList } from '../../../../empresa/empresas-list/core/_models'
import {
  PlainHeader,
  sortableColumn,
  StackedCell,
  StatusBadge,
  TableColumn,
} from '../../../../../../components'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { TFunction } from '_metronic/i18n/Metronici18n'

// Mesmo padrão da listagem de Instituição (empresas-list/table/columns/_columns.tsx).
export const empresasColumns = (t: TFunction): ReadonlyArray<TableColumn<EmpresaList>> => [
  // CNPJ é a linha de apoio do nome fantasia; os dois seguem ordenáveis.
  sortableColumn<EmpresaList>({
    id: 'nomeFantasia',
    useQueryRequest,
    fields: [
      { field: 'nomeFantasia', label: t('cols.nomeFantasia') },
      { field: 'cnpj', label: t('cols.documento.cnpj') },
    ],
    Cell: ({ row }: CellProps<EmpresaList>) => (
      <StackedCell tabular primary={row.original.nomeFantasia} secondary={row.original.cnpj} />
    ),
  }),
  sortableColumn<EmpresaList>({
    id: 'nome',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'nome', label: t('cols.razaoSocial') }],
    Cell: ({ row }: CellProps<EmpresaList>) => <StackedCell primary={row.original.nome} />,
  }),
  {
    Header: () => <PlainHeader>{t('cols.integracao')}</PlainHeader>,
    id: 'permiteApiIntegracao',
    cellWidth: '136px',
    Cell: ({ row }: CellProps<EmpresaList>) => (
      <StatusBadge
        active={row.original.permiteApiIntegracao}
        labels={['Habilitada', 'Desabilitada']}
      />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '96px',
    align: 'end',
    Cell: ({ row }: CellProps<EmpresaList>) => <EmpresasActionsCell empresa={row.original} />,
  },
]
